export const ResponseCodes = [
  '00',
  '03',
  '04',
  '05',
  '10',
  '12',
  '13',
  '14',
  '25',
  '29',
  '30',
  '34',
  '40',
  '41',
  '43',
  '46',
  '47',
  '51',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
  '61',
  '63',
  '65',
  '75',
  '91',
  '94',
  '96',
  '98',
  '99',
  'A0',
  'A1',
  'A2',
  'A3',
  'B0'
]
